import type { MaxExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';
import { max } from 'lodash-es';

export const maxResolver = createSimpleNamedExpressionResolver<MaxExpression>(
  'max',
  max
);
